module.exports = __webpack_public_path__ + "img/arkham-proxy-showcase.1eaebe5f.png";